// extracted by mini-css-extract-plugin
export default {"page":"AssignmentsPage_page__mj8nY","loaderWrap":"AssignmentsPage_loaderWrap__I6duZ","content":"AssignmentsPage_content__tbAZe"};